export default "__VITE_ASSET__DIzyN_TM__"